import { useState } from 'react';
import { Header, Chip } from '../../shared/components';
import { useCurrentUser } from '../../shared/auth/AuthProvider';
import { SnapshotTab } from './components/results/SnapshotTab';
import { AccountDetailTab } from './components/results/AccountDetailTab';
import { ClientComparisonTab } from './components/results/ClientComparisonTab';
import { ResultsSummaryTab } from './components/results/ResultsSummaryTab';
import { ClientMappingTab } from './components/results/ClientMappingTab';
import { AccountCatalogTab } from './components/results/AccountCatalogTab';
import { ServiceTypeCatalogTab } from './components/results/ServiceTypeCatalogTab';
import { ComparativosTab } from './components/results/comparativos/ComparativosTab';

type Tab = 'snapshot' | 'detail' | 'compare' | 'summary' | 'comparativos' | 'params';
type ParamsSubTab = 'clients' | 'accounts' | 'serviceTypes';

/**
 * Módulo "Resultados Financieros" - reemplaza el archivo Excel que hoy
 * arma manualmente el área comercial. Pestañas:
 *  - Resultados del Mes   <- hoja de Ingresos/Egresos (cargue + grilla + "Por revisar")
 *  - Datos Tabla          <- histórico acumulado, generado automáticamente, con Procesar mes
 *  - Comparar Clientes    <- comparación de clientes por período
 *  - Tabla Resumen        <- pivot, calculado en vivo
 *  - Comparativos         <- análisis comparativo: año vs año, mes vs mes, acumulado, clientes, variaciones
 *  - Parámetros (admin)   <- Mapeo de Clientes, Catálogo de Cuentas, Tipo de Servicio
 */
export function ResultsPage() {
  const user = useCurrentUser();
  const [tab, setTab] = useState<Tab>('snapshot');
  const [paramsTab, setParamsTab] = useState<ParamsSubTab>('clients');

  return (
    <div>
      <Header title="Resultados Financieros" subtitle="Ingresos, gastos y utilidad por cliente" />
      <div className="space-y-6 p-4">
        <div className="flex flex-wrap gap-2">
          <Chip label="Resultados del Mes" active={tab === 'snapshot'} onClick={() => setTab('snapshot')} />
          <Chip label="Datos Tabla" active={tab === 'detail'} onClick={() => setTab('detail')} />
          <Chip label="Comparar Clientes" active={tab === 'compare'} onClick={() => setTab('compare')} />
          <Chip label="Tabla Resumen" active={tab === 'summary'} onClick={() => setTab('summary')} />
          <Chip label="Comparativos" active={tab === 'comparativos'} onClick={() => setTab('comparativos')} />
          {user.role === 'admin' && <Chip label="Parámetros" active={tab === 'params'} onClick={() => setTab('params')} />}
        </div>

        {tab === 'snapshot' && <SnapshotTab />}
        {tab === 'detail' && <AccountDetailTab />}
        {tab === 'compare' && <ClientComparisonTab />}
        {tab === 'summary' && <ResultsSummaryTab />}
        {tab === 'comparativos' && <ComparativosTab />}
        {tab === 'params' && user.role === 'admin' && (
          <div className="space-y-4">
            <div className="flex flex-wrap gap-2">
              <Chip label="Mapeo de Clientes" active={paramsTab === 'clients'} onClick={() => setParamsTab('clients')} />
              <Chip label="Catálogo de Cuentas" active={paramsTab === 'accounts'} onClick={() => setParamsTab('accounts')} />
              <Chip label="Tipo de Servicio" active={paramsTab === 'serviceTypes'} onClick={() => setParamsTab('serviceTypes')} />
            </div>
            {paramsTab === 'clients' && <ClientMappingTab />}
            {paramsTab === 'accounts' && <AccountCatalogTab />}
            {paramsTab === 'serviceTypes' && <ServiceTypeCatalogTab />}
          </div>
        )}
      </div>
    </div>
  );
}
